import { useMemo, useState } from "react";
import {
  DefectStatus,
  DefectStatusEntry,
  PunchlistText,
  StatusButton,
  StatusIcon,
  StatusSelect,
} from "../..";
import { Button, Label, Modal, TextInput } from "imagine-ui";
import { useTranslation } from "react-i18next";
import { UserRole } from "imagine-users";

interface Props {
  onSave?: (status: DefectStatusEntry) => void;
  className?: string;
  commentMandatory?: boolean;
  onClose?: () => void;
  userRole: UserRole;
}

export const StatusModal = (props: Props) => {
  const [showEditor, setShowEditor] = useState(false);
  const { t } = useTranslation();
  const [status, setStatus] = useState<DefectStatus>(0);
  const [text, setText] = useState<string>("");

  const save = () => {
    const statusEntry: DefectStatusEntry = {
      status: status,
      text: text,
      userRole: props.userRole,
    };
    if (props.onSave) {
      props.onSave(statusEntry);
    }
  };

  const saveDisabled = useMemo(() => {
    return status === DefectStatus.NONE || (props.commentMandatory && !text);
  }, [status, text, props.commentMandatory]);

  return (
    <Modal
      title={t("punchlist:updateStatus")}
      visible
      onConfirm={save}
      confirmText={t("imagine:save")}
      onClose={props.onClose}
      confirmDisabled={saveDisabled}
    >
      <div className="column gap">
        <div>
          <div className="mb">
            {t("punchlist:updateAs")}{" "}
            <span className="text-bold">
              {PunchlistText.getRoleTextNoAdmin(props.userRole)}
            </span>
          </div>
          <Label>{t("imagine:status")}</Label>
          {/* <StatusSelect status={status} onChange={setStatus} /> */}
          <div className="column gap-sm">
            <StatusButton
              status={DefectStatus.OPEN}
              onClick={() => setStatus(DefectStatus.OPEN)}
              selected={status === DefectStatus.OPEN}
            />
            <StatusButton
              status={DefectStatus.IN_PROGRESS}
              onClick={() => setStatus(DefectStatus.IN_PROGRESS)}
              selected={status === DefectStatus.IN_PROGRESS}
            />
            <StatusButton
              status={DefectStatus.APPROVED}
              onClick={() => setStatus(DefectStatus.APPROVED)}
              selected={status === DefectStatus.APPROVED}
            />
            <StatusButton
              status={DefectStatus.REJECTED}
              onClick={() => setStatus(DefectStatus.REJECTED)}
              selected={status === DefectStatus.REJECTED}
            />
          </div>
        </div>
        <div>
          <Label>{t("punchlist:comment")}</Label>
          <TextInput
            value={text}
            onChange={setText}
            multiline
            maxLength={60}
            showSignsLeft
          />
        </div>
      </div>
    </Modal>
  );
};
